<template>
  <infinite-scroll v-model="loading" class="pa-0" scrollType="box" :percentualUpdate="90" height="350px" @update-data="getListTemplateMessage">
    <v-container class="mx-0 template-message" fluid>
      <v-row>
        <v-col class="py-0" cols="12">
          <v-row>
            <v-col class="pa-0" cols="12">
              <mf-search v-model="searchInput" hide-details placeholder="Busque por mensagem" />
            </v-col>
            <v-col class="pa-0" cols="12">
              <template-message-tags v-model="tags" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-data-iterator style="min-height: 180px" :items="templateMessageArray" item-key="message" :items-per-page="10000" no-data-text="" hide-default-footer>
        <template v-slot:default="{ items }">
          <v-row class="grid-message">
            <div v-for="(item, index) in items" :key="index" class="pt-0" sm="6">
              <v-card color="cinza-l90" class="elevation-0">
                <v-card-title class="pb-0">
                  <h4 class="texto-corrido">{{ item.message }}</h4>
                </v-card-title>
                <v-card-actions class="pa-0">
                  <template-message-text-counter v-model="item.message" isSms></template-message-text-counter>
                  <v-spacer />
                  <div class="button-import">
                    <mf-button text color="marca-0-l40" label="Inserir e fechar" @click="setSelectedMessage(item)" />
                  </div>
                </v-card-actions>
              </v-card>
            </div>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
  </infinite-scroll>
</template>

<script>
import InfiniteScroll from '@/components/InfiniteScroll.vue'
import TemplateMessageTags from './TemplateMessageTags.vue'
import TemplateMessageTextCounter from './TemplateMessageTextCounter.vue'

export default {
  name: 'TemplateMessageList',
  components: {
    InfiniteScroll,
    TemplateMessageTags,
    TemplateMessageTextCounter,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    search: {
      type: String,
      required: true,
    },
    getListTemplateMessage: {
      type: Function,
      required: true,
    },
    templateMessageArray: {
      type: Array,
      required: true,
    },
    filteredTags: {
      type: Array,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    loading: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    tags: {
      get() {
        return this.filteredTags
      },
      set(value) {
        this.$emit('update:filteredTags', value)
      },
    },
    searchInput: {
      get() {
        return this.search
      },
      set(value) {
        this.$emit('update:search', value)
      },
    },
  },
  methods: {
    setSelectedMessage(item) {
      this.$emit('add-new-template', item)
    },
  },
}
</script>

<style lang="scss">
.template-message {
  padding-top: 17px !important;
  overflow-x: hidden;

  .v-chip.v-size--default {
    border-radius: 4px;
    height: 25px;
  }
  .grid-message {
    -moz-column-width: 29.6em;
    -webkit-column-width: 29.6em;
    -moz-column-gap: 2.4em;
    -webkit-column-gap: 2.4em;
    display: inline-block;
    padding: 0.5rem;
    width: 100%;
  }
  .grid-message > div {
    display: inline-block;
    padding: 1rem;
    width: 100%;
  }
  .text-no-transform {
    text-transform: none;
  }
}
</style>
